import { css } from 'styled-components';
import token from 'styled-token';
import { ORIENTATIONS } from '../../constants';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
var orientationCSS = function orientationCSS(props) {
  var orientation = props.orientation,
    percentComplete = props.percentComplete,
    size = props.size;
  return token({
    size: "ProgressMeter.sizes." + size,
    transition: 'ProgressMeter.transition'
  }, function (tokens) {
    return css(["height:", ";width:", ";&::before{", ":", "%;", ":", "px;transition:", " ", ";}"], orientation === ORIENTATIONS.vertical ? '100%' : 'auto', orientation === ORIENTATIONS.vertical ? tokens.size + "px" : 'auto', orientation === ORIENTATIONS.vertical ? 'height' : 'width', percentComplete, orientation === ORIENTATIONS.vertical ? 'width' : 'height', tokens.size, orientation === ORIENTATIONS.vertical ? 'height' : 'width', tokens.transition);
  })(props);
};

/** @class ProgressBarMixin */
/** @method */
export var ProgressBarMixin = function ProgressBarMixin(props) {
  var size = props.size,
    percentComplete = props.percentComplete;
  return token({
    borderRadius: 'ProgressMeter.borderRadius',
    backgroundColor: 'ProgressMeter.backgroundColor',
    colorCompleted: 'ProgressMeter.indicatorColorCompleted',
    colorInProgress: 'ProgressMeter.indicatorColorInProgress',
    size: "ProgressMeter.sizes." + size
  }, {
    defaultValue: ''
  }, function (tokens) {
    return css(["border-radius:", "px;background-color:", ";&::before{border-radius:", "px;content:'';display:block;background-color:", ";}", ""], tokens.borderRadius, tokens.backgroundColor, tokens.borderRadius, percentComplete >= 100 ? tokens.colorCompleted : tokens.colorInProgress, inlineMediaQueryMixin('orientation', orientationCSS)(props));
  })(props);
};